import React from "react";
import cn from "classnames";
import { withTheme } from "shared/context/Theme";
import themes from "./themes";
import styles from "./styles.css";

const Button = ({
  children,
  element = "button",
  className,
  theme,
  ...rest
}) => {
  const Element = element;

  return (
    <Element {...rest} className={cn(theme.styles.button, className)}>
      {children}
    </Element>
  );
};

export default withTheme(Button, styles, themes);
